import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CheckPasswordTokenComponent } from '@common/components/reset-password/check-password-token/check-password-token.component';

const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'portal',
    loadChildren: () => import('./portal/portal.module').then((m) => m.PortalModule),
  },
  { path: 'password_reset', component: CheckPasswordTokenComponent },
  {
    path: 'locator/:uuid',
    loadComponent: () => import('./locator/locator.component').then((m) => m.LocatorComponent),
  },
  { path: '**', redirectTo: `/auth/login` },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
